// 환불 사유 "기타" 코드값 — 이 코드를 선택했을 때만 자유입력 textarea를 보여준다(RefundRequestPage.tsx
// 가 ReasonSelectModal에 넘김). 선택지 목록·라벨 자체는 더 이상 여기 하드코딩하지 않는다 — Zeus
// 공통코드(G01_REFUND_REASON, 2026-09-17 전환)에서 billingApi.getRefundReasons()로 조회한다.
export const REFUND_REASON_ETC_CODE = 'ETC';

/** DB TX_PAYMENT.REFUND_REASON_TEXT(varchar(300))와 반드시 일치해야 한다 — 안 맞으면 300자
 *  넘는 입력이 팝업·BE 검증은 통과하고 저장 시점에야 실패한다(2026-09-17 발견). */
export const REFUND_REASON_TEXT_MAX_LENGTH = 300;
